module.exports = __webpack_public_path__ + "static/media/home-slide-outlet.758e6020.png";